import { FieldValues, Path, UseFormReturn } from 'react-hook-form'

export type FieldError = {
  path: string
  message: string
}

function applyFormFieldErrors<TFieldValues extends FieldValues>(
  form: UseFormReturn<TFieldValues>,
  errors: FieldError[],
) {
  form.clearErrors()

  for (const err of errors) {
    if (!err.path) continue

    const name = err.path as Path<TFieldValues>

    // The 'ncts' type marker is read by mapFieldErrorsToNctsErrors to round-trip
    // RHF field errors back to NctsError[]. Keep it stable.
    form.setError(name, {
      type: 'ncts',
      message: err.message,
    })
  }
}

export default applyFormFieldErrors
